namespace Areas.Vendor.Profile {
    "use strict";      


    export function submitVendor() {
        const form = $("#VendorProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");
        newData.vendorStatus = "Submit";
        if (result.isValid && keyId != null) {
            sendRequest(`/Vendor/Profile/UpdateStatus/${keyId}`, JSON.stringify(newData), "PUT", (data) => { Areas.reloadPage(); });
        }
        return;
    }

    export function returnVendor() {
        const form = $("#VendorProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");
   
        if (result.isValid && keyId != null) {
            GetReasonDialog();
        }
        return;
    }


    export function GetReasonDialog() {
        const vendorReturnReasonDialog = new Areas.Dialogs.VendorReturnReasonDialog(dialogClosing);
    }

    function dialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) {
            return;
        }

        const form = $("#VendorProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const keyId: any = form.option("KeyId");
        newData.ReturnReason = data;
        newData.VendorStatus = "Return";

        sendRequest(`/Vendor/Profile/UpdateStatus/${keyId}`, JSON.stringify(newData), "PUT", (data) => { Areas.reloadPage(); });

    }

    export function approveVendor() {
        const form = $("#VendorProfileForm").dxForm("instance");
        const newData: any = form.option("formData");
        const result: any = form.validate();
        const keyId: any = form.option("KeyId");
        newData.vendorStatus = "Active";

        if (result.isValid && keyId != null) {
            sendRequest(`/Vendor/Profile/UpdateStatus/${keyId}`, JSON.stringify(newData), "PUT", (data) => { Areas.reloadPage(); });
        }
        return;
    }

}